var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5B401",
    stroke: "#F5B401",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 0L4.5 4.468H0l3.75 2.73-1.5 4.469L6 8.937l3.75 2.73-1.5-4.468L12 4.469H7.5z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBmaWxsPSIjRjVCNDAxIiBzdHJva2U9IiNGNUI0MDEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTYgMEw0LjUgNC40NjhIMGwzLjc1IDIuNzMtMS41IDQuNDY5TDYgOC45MzdsMy43NSAyLjczLTEuNS00LjQ2OEwxMiA0LjQ2OUg3LjV6Ii8+PC9zdmc+";
export { SvgStarChecked as ReactComponent };